import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"height":"100%"} }

export function render(_ctx, _cache) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": _ctx.defaultActive,
      class: "style1",
      "background-color": "#fff",
      "text-color": "#555",
      router: true,
      "active-text-color": "#FEB741"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (i, index) => {
          return (_openBlock(), _createBlock(_component_el_submenu, {
            index: index+''
          }, {
            title: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(i.icon)
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(i.title), 1)
            ]),
            default: _withCtx(() => [
              (i.item)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(i.item, (item) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      index: item.url
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 256))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["index"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}